export function progressColor(percent) {
    if (percent >= 100) return 'success';
    if (percent >= 50) return 'warning';
    return 'error';
}
